module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11SOTUX/Images/cover.jpg?1685327666558",
      "alt": "This image is the cover for the book Cross the Mountain, The Mountains"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cross the Mountain, The Mountains\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Fall Down the Mountain"), _c('br'), _vm._v("The Mountains: Book 3.2")])])]), _c('p', [_vm._v("Allan Tengerdie tumbles down easy ski slopes so often that he doesn’t believe Mark McAvoy’s assurances that he’ll enjoy cross-country skiing. Allan didn’t come to a fancy ski resort to trudge on the flats, but if a soft-in-the-middle chef has a chance to keep up with his ski patrol lover, he really ought to try.")]), _vm._v(" "), _c('p', [_vm._v("Allan and Mark have a great time on the trails, but it’s pleasure for which Allan pays dearly. How will Mark convince him to go again?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      P.D. Singer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0